import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import PropTypes from 'prop-types';

import Hubspot from '../Hubspot/Hubspot';

const RequestDemo = ({ noNegativeMargin }) => {
  return (
    <section
      className={`c-section c-section--request-demo ${
        noNegativeMargin ? '' : 'c-section--negative_mt c-section--radius'
      }`}
    >
      <Container>
        <Row className="justify-content-center">
          <Col lg={9} className="text-center">
            <h2 className="mb-5">
              <strong>Complete the form below to receive a free demo</strong>
            </h2>
            <h3 className="mb-4">
              <strong>
                An Integra Connect Specialist will be in touch for an
                introductory meeting and demo customized to your needs.
              </strong>
            </h3>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={8}>
            <Hubspot
              region="na1"
              portalId="2389949"
              formId="5b76eed8-4972-42a8-9b8b-cfc46a208689"
              sfdcCampaignId="70161000000TG15AAG"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

RequestDemo.propTypes = {
  noNegativeMargin: PropTypes.bool,
};
RequestDemo.defaultProps = {
  noNegativeMargin: false,
};

export default RequestDemo;
